var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header',[_c('ax-header'),_c('ax-banner')],1),_c('div',{staticClass:"content-main"},[_c('router-view')],1),_c('footer',[_c('ax-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }